import { logger } from '@/utils/logger';
import { AuthPage } from '@/components/auth/AuthPage';
import appServices from '@/services/appServices';
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/register')({
  component: RouteComponent,
  beforeLoad: () => {
    logger.debug('/auth/register beforeLoad check');

    // Only redirect if user is already authenticated when landing on this page
    // Guest users can access registration to upgrade their account
    if (!appServices.auth.isInitialized) {
      logger.debug('Auth service not initialized yet, waiting...');
      return;
    }

    if (appServices.auth.isAuthenticated() && !appServices.auth.isGuest()) {
      const userSettings = appServices.auth.getUserSettings();
      logger.debug(
        'User already authenticated (non-guest), userSettings:',
        userSettings
      );

      if (userSettings?.onboarding_completed === 'true') {
        logger.debug('Redirecting to /dashboard (onboarding completed)');
        throw redirect({ to: '/dashboard' });
      } else {
        logger.debug('Redirecting to /onboarding (onboarding not completed)');
        throw redirect({ to: '/onboarding' });
      }
    }

    logger.debug('Not authenticated or guest, showing register page');
  },
});

function RouteComponent() {
  const router = useRouter();
  const onBack = () => router.history.back();
  return <AuthPage mode='register' onBack={onBack} />;
}
